import { observer } from "mobx-react";
import cn from "clsx";
import styles from "./index.module.scss";
import i18next from "i18next";

import DefaultNoting from '@/assets/icons/defaultImage/defaultNoting.svg'
import AddressNothing from '@/assets/icons/defaultImage/addressNothing.svg'
import CartNothing from '@/assets/icons/defaultImage/cartNothing.svg'
import NetNothing from '@/assets/icons/defaultImage/netNothing.svg'
import OrderError from '@/assets/icons/defaultImage/orderError.svg'
import ReviewNothing from '@/assets/icons/defaultImage/reviewNothing.svg'
import WishNothing from '@/assets/icons/defaultImage/wishNothing.svg'

//页面样式
export enum PageNothingLayout{
  ROW = 'row',
  COLUMN = 'column'
}

export enum DefaultImageType {
  DEFAULT_NOTING = "defaultNoting",
  ADDRESS = "addressNothing",
  CART_NOTHING = "cartNothing",
  NET_NOTHING = "netNothing",
  ORDER_ERROR = "orderError",
  REVIEW_NOTHING = "reviewNothing",
  WISH_NOTHING = "wishNothing",
}
interface LoadingIconProps {
  layout?: PageNothingLayout; // row | column
  text?: string;
  title?: string;
  style?: React.CSSProperties;
  className?: string;
  textStyle?: React.CSSProperties;
  defaultImageType?: DefaultImageType;
  defaultImageWidth?: number; // 默认图片宽度
  defaultImageHeight?: number; // 默认图片高度
  textMarginTop?: string;
}

const UKPageNothing: React.FC<LoadingIconProps> = observer(
  ({
    layout = PageNothingLayout.COLUMN,
    text,
    title,
    className,
    style,
    textStyle,
    defaultImageType,
    defaultImageWidth = 120,
    defaultImageHeight = 120,
    textMarginTop = '8px',
  }) => {
    return (
      <div className={cn(styles.pageError, className)} style={style}>
        <div className={cn(layout === PageNothingLayout.ROW ? styles.row : styles.column)}>
          {!defaultImageType || defaultImageType === DefaultImageType.DEFAULT_NOTING ? (
            <DefaultNoting width={defaultImageWidth} height={defaultImageHeight} />
          ) : defaultImageType === DefaultImageType.ADDRESS ? (
            <AddressNothing width={defaultImageWidth} height={defaultImageHeight} />
          ) : defaultImageType === DefaultImageType.CART_NOTHING ? (
            <CartNothing width={defaultImageWidth} height={defaultImageHeight} />
          ) : defaultImageType === DefaultImageType.NET_NOTHING ? (
            <NetNothing width={defaultImageWidth} height={defaultImageHeight} />
          ) : defaultImageType === DefaultImageType.ORDER_ERROR ? (
            <OrderError width={defaultImageWidth} height={defaultImageHeight} />
          ) : defaultImageType === DefaultImageType.REVIEW_NOTHING ? (
            <ReviewNothing width={defaultImageWidth} height={defaultImageHeight} />
          ) : defaultImageType === DefaultImageType.WISH_NOTHING ? (
            <WishNothing width={defaultImageWidth} height={defaultImageHeight} />
          ) : (
            <DefaultNoting width={defaultImageWidth} height={defaultImageHeight} />
          )}
          <div className={styles.pageErrorTextBox}>
            {title && <div className={styles.pageErrorTitle}>{title}</div>}
            <div
              className={styles.pageErrorText}
              style={{ marginTop: textMarginTop, ...textStyle }}
            >
              {text ? text : i18next.t ? i18next.t('common.pageStatus.nothing') : ''}
            </div>
          </div>
        </div>
      </div>
    );
  },
);

export default UKPageNothing;
